<template>
  <div>
    <tabs v-loading="endpointResetLoader || webexLoading" style="z-index: 2002 !important;" :element-loading-text="webexLoading ? $t('message.Loading Webex Please wait It may take a minute') : ''" @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">
      <!-- Waiting Room -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.waitingRoom" label="waiting-room">
        <template slot="label">
          <i class="fa fa-clinic-medical" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'waiting-room',
            }); getWaitingAppointments();
          "></i>
        </template>
        <div style="height: 100%">
          <div class="col-lg-12 col-md-12 col-sm-12 pt-2" style="height: 100%;overflow:scroll;" v-if="appointments && appointments.length > 0">
            <appointment-card v-for="appointment in appointments" :key="appointment._id" :appointment="appointment" @appointment-declined="getWaitingAppointments()"></appointment-card>
            <infinite-loading spinner="waveDots" @infinite="getWaitingAppointments" forceUseInfiniteWrapper="window">
              <span slot="no-more">{{ $t("message.No more appointments") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!appointments || appointments.length < 1">
            <i style="display: block;"> {{ $t("message.No Live Consults queued for you at the moment") }} </i>
            <queue-svg style="max-width: 100%; height: auto; margin-top: 20em;"></queue-svg>
          </div>
        </div>
      </tab-pane>

      <!-- Scheduled Appointments -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.scheduledAppointments" label="scheduled-appts">
        <template slot="label">
          <i class="fa fa-calendar" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'scheduled-appts',
            }); getScheduledAppointments();
          "></i>
        </template>
        <div style="height:100%">
          <div class="col-6 offset-3 pb-1">
            <el-date-picker v-model="scheduledApptDateFilter" type="date" format="dd-MM-yyyy" align="center" :picker-options="datePickerOptions" :editable="false"></el-date-picker>
          </div>
          <!-- below height is set so that the filters above dont scroll outside the view, because body height and wrapper height is removed -->
          <div class="col-12 pt-3" style="height: calc(100vh - 10em);overflow:scroll; padding-bottom: 3em;" v-if="scheduledAppointments.length > 0">
            <div v-for="appointment in scheduledAppointments" :key="appointment._id">
              <appointment-card :appointment="appointment" @appointment-declined="getScheduledAppointments()"></appointment-card>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getScheduledAppointments" forceUseInfiniteWrapper="window">
              <span slot="no-more">{{ $t("message.No more appointments") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!scheduledAppointments || scheduledAppointments.length < 1
            ">
            <i>{{ $t("message.No Appointments scheduled") }}</i>
            <booking-svg style="width: 100%; max-height: 50%;"></booking-svg>
          </div>
        </div>
      </tab-pane>

      <!-- Completed Appointments -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.myConsults" label="completed-appts">
        <template slot="label">
          <i class="fa fa-history" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'completed-appts',
            }); getCompletedAppointments();
          "></i>
        </template>
        <div style="height:100%">

          <!-- Added w-100 to avoid overflowing -->
          <div class="row pb-1 w-100">
            <div class="col-6 offset-1">
              <el-date-picker v-model="completedApptDateFilter" type="date" format="dd-MM-yyyy" :picker-options="datePickerOptions" :editable="false"></el-date-picker>
            </div>
            <div class="col-4">
              <checkbox v-on:input="changePostponedAppointmentValue()" :disabled="getCompletedAppointmentsExecuting">
                {{ $t("message.Postponed") }}
              </checkbox>
            </div>
          </div>
          <!-- below height is set so that the filters above dont scroll outside the view, because body height and wrapper height is removed -->
          <div class="col-12 pt-3" style="height: calc(100vh - 10em); overflow:scroll; padding-bottom: 2em;" v-if="completedAppointments.length > 0">
            <card class="card-stats" v-for="appointment in completedAppointments" :key="appointment._id">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div v-if="appointment.referenceId" class="row appointment-id justify-content-end pr-4">
                    <div class="" style="font-size: small; font-weight: 600;">
                      <span style="margin-right: 0.5em">
                        <i class="fas fa-hashtag"></i>
                      </span>
                      <span>{{ appointment.referenceId }}</span>
                    </div>
                  </div>
                  <div class="row visit-details details">
                    <div class="col-3 col-md-4 pr-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img :src="avatarImage" class="picture-src" style="
                                  width: 100px;
                                  border-radius: 50%;
                                  outline-color: transparent;
                                " />
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                            <span>
                              <i class="fa fa-mars"></i>
                            </span>
                          </div>
                          <div v-if="appointment.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                            <span>
                              <i class="fa fa-venus"></i>
                            </span>
                          </div>
                          <div v-if="appointment.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                            <span>
                              <i class="fa fa-transgender-alt"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-md-8 right">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{ appointment.patient.firstName }}
                              {{ appointment.patient.lastName }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-info-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-10 col-9 pl-0">
                            <span>{{ appointment.patient.patientId }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-birthday-cake"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{
                              getAge(appointment.patient.dob)
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-mobile"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{
                              appointment.patient.mobileNumber
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{ appointment.reason }}</span>
                          </div>
                        </div>
                        <div class="row" v-if="appointment.appointmentType == 'Scheduled'">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock-o"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{
                              getAppointmentDatetime(
                                appointment.scheduledTimestamp.start
                              )
                            }}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button v-if="appointment.latestStatus != 'Postponed'" type="primary" class="btn-padding light mr-2" round @click.native="viewAppointmentDetails(appointment)">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
                <n-button v-if="appointment.latestStatus == 'Postponed'" type="primary" class="btn-padding light mr-2" round @click.native="reviewAppointment(appointment)">
                  <i slot="label" class="fa fa-sign-in-alt"></i>
                  {{ $t("message.Review") }}
                </n-button>
                <n-button type="primary" class="btn-padding light mr-2" v-if="settings && settings.vMaatuSettings && settings.vMaatuSettings.recordingEnabled" simple round @click.native="viewRecording(appointment)">
                  <i slot="label" class="fa fa-video"></i>
                  {{ $t("message.View Recording") }}
                </n-button>
              </div>
            </card>
            <infinite-loading spinner="waveDots" @infinite="getCompletedAppointments">
              <span slot="no-more">{{ $t("message.No more appointments") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="(!completedAppointments || completedAppointments.length < 1) && !getCompletedAppointmentsExecuting
            " style="padding-top: 3em">
            <i>{{ $t("message.No consultations found for this date") }}</i>
            <booking-svg style="max-width: 100%;"></booking-svg>
          </div>
          <infinite-loading spinner="waveDots" v-if="(!completedAppointments || completedAppointments.length < 1) && getCompletedAppointmentsExecuting">
          </infinite-loading>
        </div>
      </tab-pane>

      <!-- Icu -->
      <tab-pane v-if="settings && settings.icu && settings.icu.icuEnabled" label="icu-tab">
        <template slot="label">
          <i class="fas fa-procedures" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'icu-tab',
            })
            "></i>
        </template>
        <div style="height:100%">
          <div class="col-12 pt-3" style="height:100%;overflow: scroll; padding-bottom: 3em;">
            <card v-for="endpoint in IcuEndpoints" :key="endpoint._id">
              <div class="container">
                <div class="row">
                  <div class="col-1 text-right p-0" :class="[endpoint.status == 'Free' ? 'text-success' : '', endpoint.status == 'Offline' ? 'text-muted' : '', endpoint.status == 'Busy' ? 'text-danger' : '']">
                    <span style=" font-size: 1em">
                      <i class="fas fa-circle"></i>
                    </span>
                  </div>
                  <div class="col-8">
                  </div>
                  <div class="col-3 p-0">
                    <div class="battery-status dark" v-if="endpoint.batteryStatus">
                      <div class="batteryContainer">
                        <span class="mr-1">{{ getBatteryPercnetage(endpoint.batteryStatus.batteryChargePercentage) }}<span>%</span></span>
                        <div class="batteryOuter">
                          <div id="batteryLevel" :style="{ width: getBatteryPercnetage(endpoint.batteryStatus.batteryChargePercentage) + '%', backgroundColor: (endpoint.batteryStatus.batteryChargePercentage > 15) ? '#18ce0f' : '#d82e2e' }"></div>
                        </div>
                        <div class="batteryBump"></div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-3">
                    <h5 class="card-title">{{ endpoint.name }}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="card-text">
                      {{ endpoint.description }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <n-button type="primary" round @click.native="startEVisit(endpoint)" v-if="endpoint.status !== 'Busy' && endpoint.status !== 'Offline'">
                      <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                      {{ $t("message.Start E-visit") }}
                    </n-button>
                    <n-button type="primary" round simple v-if="((endpoint.status == 'Busy'))" @click.native="reset(endpoint)">
                      <i slot="label" class="now-ui-icons arrows-1_refresh-69"></i>
                      {{ $t("message.Reset") }}
                    </n-button>
                    <n-button type="primary" class="ml-1" round v-if="((endpoint.status == 'Busy') && endpoint.SHOW_RESUME_BUTTON)" @click.native="resumeIcuVisit(endpoint)">
                      <i slot="label" class="now-ui-icons media-1_button-play"></i>
                      {{ $t("message.Resume") }}
                    </n-button>
                    <tag class="m-0 text-muted mt-2" round v-if="endpoint.status == 'Offline'" style="text-transform: none">
                      <i class="fa fa-exclamation-circle pr-1"></i> {{ $t('message.OFFLINE') }}
                    </tag>
                  </div>
                </div>
              </div>
            </card>
            <infinite-loading spinner="waveDots" @infinite="getIcuEndpoints" forceUseInfiniteWrapper="window">
              <span slot="no-more">{{ $t("message.No more endpoints") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
        </div>
      </tab-pane>

      <!-- Messages -->
      <tab-pane v-if="user.roles.includes('doctor') &&
        user.tabsEnabled &&
        user.tabsEnabled.messages
        " label="messaging">
        <template slot="label">
          <i class="fa fa-comments" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'messaging',
            })
            "></i>
          <badge type="info" style="position: absolute; top: 10px; display: none" ref="message-badge">
            <i class="fa fa-info" style="line-height: inherit; font-size: inherit"></i>
          </badge>
        </template>
        <div class="col-12" v-if="!messages || messages.length == 0">
          <p class="text-center">{{ $t("message.No messages yet") }}</p>
        </div>

        <div class="col-12" style="height: 630px">
          <div class="row">
            <div class="col-6">
              <fg-input :placeholder="$t('message.Search')" v-model="messageTextFilter" addon-right-icon="fa fa-search" class="no-border"></fg-input>
            </div>
            <div class="col-6">
              <el-date-picker v-model="messageDateFilter" type="date" format="dd-MM-yyyy" :placeholder="$t('message.Pick a day')" class="form-group no-border" :editable="false"></el-date-picker>
            </div>
          </div>

          <div v-if="messages">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3">
                <!-- List for extra small devices -->
                <div class="row d-block d-md-none d-lg-none">
                  <div class="col-12 message-list" v-for="message in filteredMessages" :key="message._id">
                    <div @click="viewMessage(message)">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-2 col-md-1 col-lg-3">
                            <i class="now-ui-icons ui-2_chat-round message-icon"></i>
                          </div>
                          <div class="col-10 col-md-11 col-lg-9">
                            <p class="card-heading reason">
                              {{ message.from.firstName }}
                              {{ message.from.lastName }}
                            </p>
                            <p class="card-heading">
                              {{ message.subject }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <badge type="info" style="position: absolute; top: 10px" v-if="unreadChatList.indexOf(message._id) > -1">1</badge>
                  </div>
                </div>

                <!-- List for all other bigger deviecs -->
                <div class="row d-none d-md-block d-lg-block" style="height: 84vh; overflow-y: scroll">
                  <div :class="'col-12 message-list ' +
                    (selectedMessage &&
                      selectedMessage.date == message.date
                      ? 'selected'
                      : '')
                    " v-for="message in filteredMessages" :key="message._id">
                    <div @click="selectMessage(message)">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-2 col-lg-2">
                            <i class="now-ui-icons ui-2_chat-round message-icon"></i>
                          </div>
                          <div class="col-10 col-lg-10">
                            <p class="card-heading reason">
                              {{ message.to.firstName }}
                              {{ message.to.lastName }}
                            </p>
                            <p class="card-heading">
                              {{ message.subject }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-8 col-lg-9 d-none d-md-block d-lg-block d-xl-none">
                <message v-if="selectedMessage"></message>
              </div>
            </div>
          </div>
        </div>

        <n-pagination :page-count="messagesPagination.totalPages" v-model="messagesPagination.pageNumber"></n-pagination>
      </tab-pane>

      <tab-pane label="forum" v-if="IS_FORUM_ENABLED()">
        <template slot="label">
          <i class="fas fa-comments" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'forum',
            })
            "></i>
        </template>
        <forum v-if="activeTab == 'forum'"></forum>
      </tab-pane>
    </tabs>
    <call-notification v-if="callNotification" :caller="caller" :callType="'incoming'" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()">
    </call-notification>
    <need-help-modal></need-help-modal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import Forum from "../components/forum/Forum.vue";

import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import {
  StatsCard,
  Switch,
  TimeLine,
  TimeLineItem,
  Table as NTable,
  Checkbox,
} from "src/components";
import { DatePicker } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import { Carousel, Slide } from "vue-carousel";
import CallNotification from "../../../components/CallNotification";
import Message from "src/pages/carenation/Message.vue";
import socket from "@/services/socket";
import AppointmentCard from "../components/AppointmentCard.vue";
import avatarImage from "@/assets/img/proAvatar.png";
import moment from "moment-timezone";
import { Tag } from "element-ui";
import BookingSvg from "../components/svg_images/BookingSvg.vue";
import QueueSvg from "../components/svg_images/QueueSvg.vue";
import NeedHelpModal from "../components/NeedHelpModal";

export default {
  name: "home",

  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Switch.name]: Switch,
    TimeLine,
    TimeLineItem,
    NTable,
    Checkbox,
    [DatePicker.name]: DatePicker,
    Message,
    Modal,
    CoolSelect,
    Carousel,
    Slide,
    AppointmentCard,
    CallNotification,
    Tag,
    BookingSvg,
    QueueSvg,
    Forum,
    NeedHelpModal,
  },

  data() {
    return {
      isLoading: false,
      icuEndpointData: null,
      avatarImage,
      searchText: "",
      appointment: null,
      Authentication: {},
      currentPage: 0,
      cardName: null,
      cardDescription: null,
      careCoordinatorList: null,
      messageTextFilter: null,
      messageDateFilter: null,
      appointmentsDateFilter: new Date(),
      selectedMessage: null,
      APPT_REQUESTED: false,
      simpleMeetingsQuery: {},
      CREATE_NEW_MESSAGE: false,
      subject: null,
      selectedDoctor: null,
      doctorSearchText: "john",
      filteredDoctorList: [],
      CARECO_JOINED: false,
      CARECARDS_LOADED: false,
      UNREAD_MESSAGE: true,
      unreadChatList: [],
      SHOW_VC: true,
      datePickerOptions: {},
      scheduledApptDateFilter: new Date(),
      appointments: [],
      scheduledAppointments: [],
      completedApptDateFilter: new Date(),
      completedAppointments: [],
      POSTPONED_APPOINTMENTS: false,
      messages: [],
      IcuEndpoints: [],
      IcuAppointments: [],
      waitingRoomPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      scheduledApptsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      completedApptsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      messagesPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      IcuEndpointsPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      caller: {},
      callNotification: false,
      incomingCallAppt: {},
      appointmentMessages: [],
      loader: null,
      getCompletedAppointmentsExecuting: true,
      remoteUser: null,
      webexLoading: false,
      endpointResetLoader: false,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    activeTab() {
      return this.$store.state.homePageActiveTab;
    },
    FCMpayload() {
      return this.$store.state.FCMpayload;
    },

    //Messages
    filteredMessages() {
      if (this.messages) {
        return this.messages.filter((message) => {
          return (
            (!this.messageTextFilter ||
              (message.subject &&
                (message.subject
                  .toLowerCase()
                  .indexOf(this.messageTextFilter.toLowerCase()) > -1 ||
                  message.from.firstName
                    .toLowerCase()
                    .indexOf(this.messageTextFilter.toLowerCase()) > -1 ||
                  message.from.lastName
                    .toLowerCase()
                    .indexOf(this.messageTextFilter.toLowerCase()) > -1))) &&
            (!this.messageDateFilter ||
              moment(this.messageDateFilter).format("MMMM Do YYYY") ==
              moment(message.date).format("MMMM Do YYYY"))
          );
        });
      }
    },
  },

  watch: {
    scheduledApptDateFilter: function () {
      this.getScheduledAppointments();
    },
    completedApptDateFilter: function () {
      this.getCompletedAppointments();
    },
    "messagesPagination.pageNumber": function () {
      this.getMessages();
    },
  },

  methods: {
    IS_FORUM_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.forum &&
        this.settings.patientAppSetting.forum.enabled
      );
    },

    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    changePostponedAppointmentValue() {
      this.getCompletedAppointmentsExecuting = true;
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.POSTPONED_APPOINTMENTS = !this.POSTPONED_APPOINTMENTS;
      this.completedAppointments = [];
      this.completedApptsPagination = {
        pageNumber: 1,
        totalPages: 0,
      };
      this.getCompletedAppointments();
    },
    init() {
      this.getWaitingAppointments();
      this.getMessages();
      this.getScheduledAppointments();
      this.getCompletedAppointments();
      this.getIcuEndpoints();
    },
    async onCallDeclined() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.incomingCallAppt._id,
        status: "declined",
      });

      if (response && response._id) {
        let message = {
          username: this.incomingCallAppt.provider.username,
          status: "declined",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });
        socket.emit("leaveRoom", {
          type: "appointment",
          id: this.incomingCallAppt._id,
          userId: this.user._id,
        });
      }
    },
    async onCallAccepted() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.incomingCallAppt._id,
        status: "accepted",
      });

      if (response && response._id) {
        let message = {
          username: this.incomingCallAppt.provider.username,
          status: "accepted",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });
        this.join(this.incomingCallAppt);
      }
    },
    async join(appt) {
      try {
        if (appt && appt.appointmentType == "Live") {
          if (
            appt.latestStatus == "Assigned" ||
            appt.latestStatus == "InProgress" ||
            appt.latestStatus == "Paused"
          ) {
            //If appointment is for speciality
            if (!appt.provider || !appt.provider.providerId) {
              var provider = {
                providerId: this.user._id,
                username: this.user.username,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                specialityText: this.user.specialityText,
                timezone: this.user.timezone,
                description: this.user.description,
                UIN: this.user.UIN,
              };

              //Get appointment's endpoint details
              let endpoint = await this.$store.dispatch(
                "getEndpoint",
                appt.endpoint
              );
              if (
                endpoint &&
                endpoint.billingDetails.enabled &&
                endpoint.billingDetails.pricingType &&
                endpoint.billingDetails.value
              ) {
                var doctorsPrice = this.user.billingDetails.enabled
                  ? this.user.billingDetails.amount
                  : 0;

                var billingDetails = {
                  currency: this.user.billingDetails.currency,
                };

                //Calculate amount based on endpoints configuration
                switch (endpoint.billingDetails.pricingType) {
                  case "fixedPrice":
                    billingDetails.amount = endpoint.billingDetails.value;
                    break;
                  case "fixedMargin":
                    billingDetails.amount =
                      parseInt(doctorsPrice) +
                      parseInt(endpoint.billingDetails.value);
                    break;
                  case "percentageMargin":
                    billingDetails.amount =
                      parseInt(doctorsPrice) +
                      parseInt(doctorsPrice) *
                      (parseInt(endpoint.billingDetails.value) / 100);
                    break;
                  default:
                    billingDetails.amount = doctorsPrice;
                }
              }

              //Make this doctor as doctor for the appointment
              try {
                appt = await this.$store.dispatch(
                  "updateDoctorForAppointment",
                  {
                    appointmentId: appt._id,
                    provider: provider,
                    billingDetails: billingDetails,
                  }
                );

                //Mark appointment as in-progress
                try {
                  appt = await this.$store.dispatch("updateStatus", {
                    appointmentId: appt._id,
                    status: "InProgress",
                  });

                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    userId: this.user._id,
                  });
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    endpointId: appt.endpoint,
                    userId: this.user._id,
                  });
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    specialityId: appt.specialityId,
                    userId: this.user._id,
                  });

                  console.log("settng", appt);
                  this.$store.commit("setState", {
                    stateName: "appointment",
                    stateValue: appt,
                  });

                  this.$router.push("telemed");
                } catch (e) {
                  this.getAppointments();

                  if (e.code == "APPT_DELETED") {
                    swal.fire(this.$t("message.Appointment has been deleted"));
                  } else if (e.code == "APPT_CLOSED") {
                    swal.fire(this.$t("message.Appointment has been closed by the nurse"));
                  } else {
                    swal.fire({
                      title: this.$t("message.Appointment error"),
                      text: this.$t("message.Problem joining the appointment Contact Administrator"),
                      type: "error",
                      timer: 5000,
                    });
                  }
                }
              } catch (e) {
                this.getAppointments();

                //If appointment is already responded by another provider
                if (e.code && e.code == "APPT_RESPONDED") {
                  swal.fire({
                    title: this.$t("message.Appointment info"),
                    text: this.$t("message.Appointment was responded by another doctor"),
                    type: "info",
                    timer: 4000,
                  });
                } else {
                  swal.fire({
                    title: this.$t("message.Appointment error"),
                    text: this.$t("message.Problem joining the appointment Contact Administrator"),
                    type: "error",
                    timer: 5000,
                  });
                }
              }
            }

            //If this provider is the primary provider for the appointment
            else if (this.user._id == appt.provider.providerId) {
              try {
                appt = await this.$store.dispatch("updateStatus", {
                  appointmentId: appt._id,
                  status: "InProgress",
                });

                //If doctor's endpoint is SPARK_EMBEDDED
                if (this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                  //Get remote user
                  try {
                    let remoteUser = await this.$store.dispatch(
                      "getUserById",
                      appt.user
                    );

                    if (
                      this.appointment.consultationType == "telemed-direct" &&
                      this.settings.directTelemedicine.videoConfType ==
                      "WEBEX_TEAMS"
                    ) {
                      requestData.members.push({
                        isGuest: true,
                        participantEmail:
                          remoteUser.webexTeams.guestParticipantEmail,
                        participantId: remoteUser.webexTeams.guestParticipantId,
                      });

                      //Creating Webex room
                      await this.$store.dispatch(
                        "createWebexRoom",
                        requestData
                      );
                    } else {
                      //Get endpoint details assigned to appointment
                      let endpoint = await this.$store.dispatch(
                        "getEndpoint",
                        appt.endpoint
                      );

                      let requestData = {
                        userId: this.user._id,
                        appointmentId: appt._id,
                        members: [],
                      };

                      //If remote user's endpoint is SPARK_EMBEDDED
                      if (endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                        requestData.members.push({
                          isGuest: false,
                          participantEmail:
                            endpoint.videoConfDetails.phoneNumber ||
                            remoteUser.email,
                        });
                      }

                      //If remote user's endpoint is WEBEXTEAMS_GUEST
                      else if (endpoint.videoConfEPType == "WEBEXTEAMS_GUEST") {
                        requestData.members.push({
                          isGuest: true,
                          participantEmail:
                            remoteUser.webexTeams.guestParticipantEmail,
                          participantId:
                            remoteUser.webexTeams.guestParticipantId,
                        });
                      }

                      //Creating Webex room
                      await this.$store.dispatch(
                        "createWebexRoom",
                        requestData
                      );
                    }

                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });

                    console.log("settng", appt);

                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });

                    this.$router.push("telemed");
                    /*socket.emit("joinRoom", {
                    type: "appointment",
                    id: appt._id,
                  });*/
                  } catch (e) {
                    console.log(e);
                  }
                } else {
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    userId: this.user._id,
                  });
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    endpointId: appt.endpoint,
                    userId: this.user._id,
                  });

                  this.$store.commit("setState", {
                    stateName: "appointment",
                    stateValue: appt,
                  });
                  this.$router.push("telemed");
                }
              } catch (err) {
                if (err.code == "APPT_DELETED") {
                  swal.fire(this.$t("message.Appointment has been deleted"));
                } else {
                  swal.fire(this.$t("message.Error joining appointment"));
                }
              }
            }

            //If this provider is the secondary provider for the appointment
            else if (this.user._id != appt.provider.providerId) {
              var isSecondaryProvider = false;
              appt.secondaryProviders.forEach(async function (provider) {
                if (
                  provider.providerId == this.user._id &&
                  !isSecondaryProvider
                ) {
                  isSecondaryProvider = true;

                  try {
                    await this.$store.dispatch(
                      "updateStatusSecondaryProvider",
                      {
                        appointmentId: appt._id,
                        providerId: provider.providerId,
                        status: "joined",
                      }
                    );

                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });

                    console.log("settng", appt);
                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });

                    this.$router.push("telemed");
                  } catch (e) {
                    console.log(e);
                  }
                }

                if (!isSecondaryProvider) {
                  this.getAppointments();
                  swal.fire({
                    title: "Info",
                    text:
                      this.$t("message.Appointment was responded by Dr") +
                      appt.provider.firstName +
                      " " +
                      appt.provider.lastName,
                    timer: 2000,
                    type: "info",
                  });
                }
              });
            }
          }
        } else if (appt && appt.appointmentType == "Scheduled") {
          //Mark appointment as in-progress
          try {
            if (this.user._id == appt.provider.providerId) {
              try {
                appt = await this.$store.dispatch("updateStatus", {
                  appointmentId: appt._id,
                  status: "InProgress",
                });

                //If doctor's endpoint is SPARK_EMBEDDED
                this.loaderText = this.$t("message.Setting up WEBEX room for this appointment");
                if (this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                  //Get remote user
                  try {
                    let requestData = {
                      userId: this.user._id,
                      appointmentId: appt._id,
                      members: [],
                    };

                    let remoteUser = await this.$store.dispatch(
                      "getUserById",
                      appt.user
                    );

                    if (
                      this.appointment.consultationType == "telemed-direct" &&
                      this.settings.directTelemedicine.videoConfType ==
                      "WEBEX_TEAMS"
                    ) {
                      requestData.members.push({
                        isGuest: true,
                        participantEmail:
                          remoteUser.webexTeams.guestParticipantEmail,
                        participantId: remoteUser.webexTeams.guestParticipantId,
                      });

                      console.log(requestData);

                      //Creating Webex room
                      await this.$store.dispatch(
                        "createWebexRoom",
                        requestData
                      );
                    } else {
                      //Get endpoint details assigned to appointment
                      let endpoint = await this.$store.dispatch(
                        "getEndpoint",
                        appt.endpoint
                      );

                      let requestData = {
                        userId: this.user._id,
                        appointmentId: appt._id,
                        members: [],
                      };

                      //If remote user's endpoint is SPARK_EMBEDDED
                      if (endpoint.videoConfEPType == "SPARK_EMBEDDED") {
                        requestData.members.push({
                          isGuest: false,
                          participantEmail:
                            endpoint.videoConfDetails.phoneNumber ||
                            remoteUser.email,
                        });
                      }

                      //If remote user's endpoint is WEBEXTEAMS_GUEST
                      else if (endpoint.videoConfEPType == "WEBEXTEAMS_GUEST") {
                        requestData.members.push({
                          isGuest: true,
                          participantEmail:
                            remoteUser.webexTeams.guestParticipantEmail,
                          participantId:
                            remoteUser.webexTeams.guestParticipantId,
                        });
                      }

                      //Creating Webex room
                      await this.$store.dispatch(
                        "createWebexRoom",
                        requestData
                      );
                    }

                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      endpointId: appt.endpoint,
                      userId: this.user._id,
                    });
                    socket.emit("appointmentJoined", {
                      appointmentId: appt._id,
                      specialityId: appt.specialityId,
                      userId: this.user._id,
                    });

                    this.$store.commit("setState", {
                      stateName: "appointment",
                      stateValue: appt,
                    });

                    this.$router.push("telemed");
                  } catch (e) {
                    console.log(e);
                  }
                } else {
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    userId: this.user._id,
                  });
                  socket.emit("appointmentJoined", {
                    appointmentId: appt._id,
                    endpointId: appt.endpoint,
                    userId: this.user._id,
                  });

                  this.$store.commit("setState", {
                    stateName: "appointment",
                    stateValue: appt,
                  });
                  this.$router.push("telemed");
                }
              } catch (err) {
                if (err.code == "APPT_DELETED") {
                  swal.fire(this.$t("message.Appointment has been deleted"));
                } else {
                  swal.fire(this.$t("message.Error joining appointment"));
                }
              }
            }
          } catch (e) {
            if (e.code == "APPT_DELETED") {
              swal.fire(this.$t("message.Appointment has been deleted"));
            } else {
              swal.fire({
                title: this.$t("message.Appointment error"),
                text: this.$t("message.Problem joining the appointment Contact Administrator"),
                type: "error",
                timer: 5000,
              });
            }
          }
        } else {
          this.loading = false;
          this.getAppointments();
          swal.fire({
            title: this.$t("message.Appointment error"),
            text: this.$t("message.Problem joining the appointment Contact Administrator"),
            type: "error",
            timer: 5000,
          });
        }
      } catch (e) {
        console.log(e);
        this.LOADING = false;
      }
    },
    onCallMissed() {
      this.callNotification = false;
      socket.emit("leaveRoom", {
        type: "appointment",
        id: this.incomingCallAppt._id,
        userId: this.user._id,
      });
    },
    async onCallPushNotification(payload, join) {
      let that = this;
      that.incomingCallAppt = await that.$store.dispatch(
        "getAppointment",
        payload.appointmentId
      );

      //Get Appointment messages
      if (that.incomingCallAppt) {
        let response = await this.$store.dispatch(
          "getAppointmentMessages",
          that.incomingCallAppt._id
        );
        that.appointmentMessages = response;
      }

      for (let i = that.appointmentMessages.length - 1; i >= 0; i--) {
        if (
          that.appointmentMessages[i].content &&
          that.appointmentMessages[i].content == "Video call"
        ) {
          if (that.incomingCallAppt.chatMessages[i].status == "initiated") {
            if (that.incomingCallAppt.consultationType == "telemed-direct") {
              that.remoteUser = {
                id: that.incomingCallAppt.patient.patientId,
                name:
                  that.incomingCallAppt.patient.firstName +
                  " " +
                  that.incomingCallAppt.patient.lastName,
                imageUrl: that.avatarImage,
              };
            } else {
              if (
                that.incomingCallAppt.user &&
                that.incomingCallAppt.createdBy == "nurse"
              ) {
                let nurse = await that.$store.dispatch(
                  "getUserById",
                  that.incomingCallAppt.user
                );
                let nurseDisplayPic = that.avatarImage;
                if (nurse.profileImage) {
                  nurseDisplayPic = `${that.$store.state.baseUrl}/file/${nurse.profileImage}`;
                }
                that.remoteUser = {
                  id: nurse.username,
                  name: nurse.firstName + " " + nurse.lastName,
                  imageUrl: nurseDisplayPic,
                };
              }
            }
            that.caller.img = that.remoteUser.imageUrl;
            that.caller.name = that.remoteUser.name;
            that.callNotification = true;

            socket.emit("joinRoom", {
              type: "appointment",
              id: that.incomingCallAppt._id,
              userId: that.user._id,
            });
          } else {
            if (join) {
              that.join(that.incomingCallAppt);
            }
          }
          break;
        }
      }
    },
    initSocket() {
      //Joining socket to be extra sure
      //Join Appointment and Speciality Room
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });
      for (let i in this.user.speciality) {
        let specialityId =
          this.user.speciality[i]._id || this.user.speciality[i];
        socket.emit("joinRoom", {
          type: "speciality",
          id: specialityId,
        });
      }
    },
    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("hh:mm a");
    },
    async getScheduledAppointments($state) {
      if (!$state) {
        this.scheduledAppointments = [];
        this.scheduledApptsPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      let filter = {
        dateStart: this.scheduledApptDateFilter.setHours(0, 0, 0, 0),
        dateEnd: this.scheduledApptDateFilter.setHours(23, 59, 59, 0),
        providerId: this.user._id,
        status: ["Created"],
      };

      let response = await this.$store.dispatch("getScheduledAppointments", {
        filter,
        pageNumber: this.scheduledApptsPagination.pageNumber,
        pageSize: 3,
      });

      if (response.data && response.data.length) {
        this.scheduledAppointments.push(...response.data);
        this.scheduledApptsPagination.totalPages = response.totalPages;
        this.scheduledApptsPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    async getWaitingAppointments($state) {
      if (!$state) {
        this.appointments = [];
        this.waitingRoomPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      let response = await this.$store.dispatch("getAppointmentsForDoctor", {
        userId: this.user._id,
        pageNumber: this.waitingRoomPagination.pageNumber,
        pageSize: 3,
      });
      if (response.data && response.data.length) {
        //Fix for duplicate cards
        response.data.forEach((data) => {
          let exists = this.appointments.some((appt) => {
            return appt._id == data._id;
          });
          if (!exists) {
            this.appointments.push(data);
          }
        });
        // this.appointments.push(...response.data);
        this.waitingRoomPagination.totalPages = response.totalPages;
        this.waitingRoomPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    async getCompletedAppointments($state) {
      try {
        this.getCompletedAppointmentsExecuting = true;
        if (!$state) {
          this.completedAppointments = [];
          this.completedApptsPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }

        let dateDetails = {
          dateStart: moment(this.completedApptDateFilter)
            .startOf("day")
            .valueOf(),
          dateEnd: moment(this.completedApptDateFilter).endOf("day").valueOf(),
        };

        //If Postponed is checked, clear the date deatails to get all appointments
        if (this.POSTPONED_APPOINTMENTS) dateDetails = null;

        this.loading = true;
        //get all the previous appointments for this provider id
        let response = await this.$store.dispatch("getCompletedAppointments", {
          pageNumber: this.completedApptsPagination.pageNumber,
          doctorId: this.user._id,
          dateDetails: dateDetails,
          POSTPONED_APPOINTMENTS: this.POSTPONED_APPOINTMENTS,
          pageSize: 2,
          ucRecordings: {
            include: true,
            instance: this.instance,
          },
        });

        if (response.data && response.data.length) {
          this.completedAppointments.push(...response.data);
          this.completedApptsPagination.totalPages = response.totalPages;
          this.completedApptsPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
        if (this.loader) {
          this.loader.hide();
          this.loader = null;
        }
        this.getCompletedAppointmentsExecuting = false;
      } catch (e) {
        if (this.loader) {
          this.loader.hide();
          this.loader = null;
        }
        this.getCompletedAppointmentsExecuting = false;
        console.log(e);
      }
    },
    viewAppointmentDetails(appointment) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      this.$router.push("viewappointmentdetails");
    },
    reviewAppointment(appointment) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      this.$router.push("postponedprescription");
    },
    viewMessage(message) {
      this.$refs["message-badge"].$el.style.display = "none";
      this.unreadChatList.splice(this.unreadChatList.indexOf(message._id), 1);
      this.$store.state.message = message;
      this.$router.push("message");
    },
    async getMessages() {
      try {
        let response = await this.$store.dispatch("getMessages", {
          userId: this.user._id,
          pageNumber: this.messagesPagination.pageNumber,
        });
        this.messages = response.data;
        this.messagesPagination.totalPages = response.totalPages;
      } catch (e) {
        console.log(e);
      }
    },
    async viewRecording(appointment) {
      try {
        let url = new URL(this.$store.state.baseUrl);
        let data = {
          roomId: `${this.instance}_${appointment._id}`,
        };
        let res = await this.$store.dispatch("getRecordings", data);
        if (res.data && res.data.length > 0) {
          this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: appointment,
          });
          this.$store.commit("setState", {
            stateName: "recordingsUrl",
            stateValue: `${url.origin}/app/viewrecordings?room_name=${this.instance}_${appointment._id}&secureroom=false`,
          });
          this.$router.push("/recordingviewer");
        } else {
          swal.fire({
            title: this.$t("message.No Recordings!"),
            text: this.$t("message.This appointment does not have any recorded sessions"),
            type: "info",
            timer: 5000,
          });
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          title: "Error",
          text: this.$t("message.There was a problem getting recordings"),
          type: "error",
          timer: 5000,
        });
      }
    },
    async getIcuEndpoints($state) {
      if (!$state) {
        this.IcuEndpoints = [];
        this.IcuEndpointsPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      this.isLoading = true;
      let response = await this.$store.dispatch("getIcuEndpoints", {
        pageNumber: this.IcuEndpointsPagination.pageNumber,
        pageSize: 4,
      });

      if (response.data && response.data.length) {
        this.IcuEndpoints.push(...response.data);
        this.IcuEndpointsPagination.totalPages = response.totalPages;
        this.IcuEndpointsPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
      this.isLoading = false;
      this.checkInprogressIcuVisit();
    },

    async checkInprogressIcuVisit() {
      this.IcuAppointments = [];
      for (const endpoint of this.IcuEndpoints) {
        if (endpoint.status && endpoint.status == "Busy") {
          let response = await this.$store.dispatch(
            "getInprogreesAppointment",
            { endpoint: endpoint }
          );
          let appt = response[0];
          if (appt) {
            //Check if the user has ongoing ICU visits and enable resume button for that endpoint card
            if (appt.provider.providerId == this.user._id) {
              this.IcuAppointments.push(appt);
              endpoint["SHOW_RESUME_BUTTON"] = true;
              this.$forceUpdate();
            }
          }
        }
      }
    },

    resumeIcuVisit(endpoint) {
      try {
        let appointmentData = null;
        this.IcuAppointments.forEach((appt) => {
          if (appt.endpoint == endpoint.name) {
            appointmentData = appt;
          }
        });
        if (appointmentData) {
          this.$store.dispatch("setIcuEndpointAndIcuAppointment", {
            icuEndpoint: endpoint,
            icuAppointment: appointmentData,
          });
          this.$router.push({ path: "/icuvisit" });
        }
      } catch (err) {
        console.log(err);
        swal.fire({
          title: "Error",
          text: this.$t("message.Unable to Resume Icu Visit Please contact administrator"),
          type: "error",
          timer: 5000,
        });
      }
    },

    async startEVisit(endpoint) {
      this.isLoading = true;
      try {
        this.icuEndpointData = await this.$store.dispatch("fetchIcuEndpoint", {
          id: endpoint._id,
        });
        if (
          this.icuEndpointData.status != "Busy" &&
          this.icuEndpointData.status != "Offline"
        ) {
          this.appointment = {};
          this.appointment.startTime = moment.utc();
          endpoint.status = "Busy";
          this.appointment.endpoint = endpoint.name;
          this.appointment.appointmentType = "icu";
          this.appointment.provider = {};
          this.appointment.provider.providerId = this.user._id;
          this.appointment.provider.username = this.user.username;
          this.appointment.provider.firstName = this.user.firstName;
          this.appointment.provider.lastName = this.user.lastName;
          this.appointment.provider.specialityText = this.user.specialityText;
          this.appointment.provider.fullName =
            this.user.firstName + " " + this.user.lastName;
          this.appointment.provider.endpoint = this.user.endpoint;

          this.appointment.appointmentStatus = [
            {
              status: "Created",
              timestamp: new Date().getTime(),
            },
            {
              status: "InProgress",
              timestamp: new Date().getTime(),
            },
          ];

          this.appointment.latestStatus = "InProgress";

          this.appointment.attendant = {
            username: endpoint.name,
          };

          await this.$store.dispatch("updateEndPointStatus", {
            endpointId: endpoint._id,
            status: endpoint.status,
          });

          let appointmentData = await this.$store.dispatch(
            "makeIcuAppointment",
            {
              appointment: this.appointment,
            }
          );

          if (
            endpoint.videoConfEPType == "VMAATU_RTC" ||
            endpoint.videoConfEPType == "VMAATU_RTC_EXTERNAL"
          ) {
            this.$store.dispatch("setIcuEndpointAndIcuAppointment", {
              icuEndpoint: endpoint,
              icuAppointment: appointmentData,
            });
            this.isLoading = false;
            this.$router.push({ path: "/icuvisit" });
          } else {
            //Create room and add icu ep as member
            //Send mqtt from server to ep to trigger room join
            this.webexLoading = true;
            let requestData = null;
            if (endpoint.videoConfEPType == "WEBEXTEAMS_GUEST") {
              try {
                let remoteUser = await this.$store.dispatch(
                  "getUserByEndpoint",
                  {
                    endpointname: endpoint.name,
                  }
                );

                requestData = {
                  userId: this.user._id,
                  appointmentId: appointmentData._id,
                  members: [
                    {
                      isGuest: true,
                      participantEmail:
                        remoteUser[0].webexTeams.guestParticipantEmail,
                      participantId:
                        remoteUser[0].webexTeams.guestParticipantId,
                    },
                  ],
                };
              } catch (err) {
                console.log(err);
              }
            } else {
              requestData = {
                userId: this.user._id,
                appointmentId: appointmentData._id,
                triggerStartCall: true,
                members: [
                  {
                    isGuest: false,
                    participantEmail: endpoint.videoConfDetails.phoneNumber,
                  },
                ],
              };
            }
            try {
              let setupResponse = await this.$store.dispatch(
                "createWebexRoom",
                requestData
              );
              console.log(
                "setupResponse.triggerCallDelay",
                setupResponse.triggerCallDelay
              );
              setTimeout(async () => {
                let res = await this.$store.dispatch(
                  "triggerCall",
                  appointmentData
                );
                console.log("triggerwebex", res);

                if (res && res.responseCode != 200) {
                  this.isLoading = false;
                  this.webexLoading = false;
                  swal.fire({
                    text: this.$t("message.Unable to load webex Please contact adminstrator"),
                    type: "error",
                    timer: 5000,
                  });
                  try {
                    await this.$store.dispatch(
                      "deleteWebexRoom",
                      appointmentData._id
                    );

                    await this.$store.dispatch("updateEndPointStatus", {
                      endpointId: endpoint._id,
                      status: "Free",
                    });
                    this.getIcuEndpoints();
                  } catch (e) {
                    console.error(e);
                  }
                } else {
                  this.$store.dispatch("setIcuEndpointAndIcuAppointment", {
                    icuEndpoint: endpoint,
                    icuAppointment: appointmentData,
                  });
                  this.isLoading = false;
                  this.webexLoading = false;
                  this.$router.push({ path: "/icuvisit" });
                }
              }, setupResponse.triggerCallDelay);
            } catch (e) {
              this.isLoading = false;
              this.webexLoading = false;
              console.log(e);
            }
          }
        } else {
          this.isLoading = false;
          this.webexLoading = false;
          let title =
            this.icuEndpointData.status == "Busy"
              ? this.$t("message.Endpoint Busy")
              : this.$t("message.Endpoint Offline");
          let text =
            this.icuEndpointData.status == "Busy"
              ? this.$t("message.Kindly wait until freed")
              : this.$t("message.ICU endpoint logged out or not reachable");

          swal.fire({
            title: title,
            text: text,
            type: "warning",
            timer: 2000,
          });

          this.getIcuEndpoints();
        }
      } catch (err) {
        this.isLoading = false;
        this.webexLoading = false;
        console.log("Error starting e-visit", err);
        swal.fire({
          title: this.$t("message.Error") + "!",
          text: this.$t("message.Could not start e-visit"),
          type: "error",
        });
        await this.$store.dispatch("resetEndpoint", {
          endpoint: endpoint,
        });
        this.getIcuEndpoints();
      }
    },
    async reset(endpoint) {
      let that = this;
      swal
        .fire({
          title: that.$t("message.Are you sure?"),
          text: that.$t("message.Any ongoing video session will be disconnected, Do you want to continue?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: that.$t("message.YES, CONTINUE"),
        })
        .then(async (result) => {
          if (result.value) {
            //swal.fire("Success", "Endpoint reset successfully", "success");
            this.endpointResetLoader = true;
            let response = await this.$store.dispatch(
              "getInprogreesAppointment",
              {
                endpoint: endpoint,
              }
            );

            if (response && response.length > 0) {
              socket.emit("forceExit", {
                appointmentId: response[0]._id,
                userId: this.user._id,
              });

              //delete webex room if webex
              if (response[0].webexTeams && response[0].webexTeams.roomId) {
                await this.$store.dispatch("deleteWebexRoom", response[0]._id);
              }

              //end appts
              response[0].latestStatus = "Completed";
              response[0].appointmentStatus.push({
                status: "Completed",
                timestamp: new Date().getTime(),
              });
              try {
                let responseData = await this.$store.dispatch(
                  "endAppointment",
                  {
                    response: response,
                  }
                );

                try {
                  await this.$store.dispatch("resetEndpoint", {
                    endpoint: endpoint,
                  });

                  setTimeout(function () {
                    that.endpointResetLoader = false;

                    that.getIcuEndpoints();
                    swal.fire({
                      title: "Success",
                      text: that.$t("message.Endpoint reset successfull"),
                      type: "success",
                      timer: 2000,
                    });
                  }, 5000);
                } catch (err) {
                  console.log(err);
                  that.endpointResetLoader = false;

                  swal.fire({
                    title: "Error",
                    text: that.$t("message.Unable to reset the Endpoint Please contact administrator"),
                    type: "error",
                    timer: 5000,
                  });
                }
              } catch {
                that.endpointResetLoader = false;
                console.log(
                  "Error updating appointment details for " +
                  this.appointment._id
                );
              }
            } else {
              try {
                await this.$store.dispatch("resetEndpoint", {
                  endpoint: endpoint,
                });

                setTimeout(function () {
                  that.endpointResetLoader = false;
                  that.getIcuEndpoints();
                  swal.fire({
                    title: "Success",
                    text: that.$t("message.Endpoint reset successfull"),
                    type: "success",
                    timer: 2000,
                  });
                }, 5000);
              } catch (err) {
                console.log(err);
                that.endpointResetLoader = false;
                swal.fire({
                  title: "Error",
                  text: that.$t("message.Unable to reset the Endpoint Please contact administrator"),
                  type: "error",
                  timer: 5000,
                });
              }
            }
          }
        });
    },

    getBatteryPercnetage(value) {
      return Math.min(value, 100);
    },
  },

  async mounted() {
    let that = this;

    if (this.user) {
      try {
        await this.$store.dispatch("updateAvailibility", {
          status: true,
          _id: this.user._id,
        });
        await this.$store.dispatch("getUserDetails", this.user._id);
        // available tabs
        let tabs = [
          {
            name: "waitingRoom",
            id: "waiting-room",
          },
          {
            name: "scheduledAppointments",
            id: "scheduled-appts",
          },
          {
            name: "myConsults",
            id: "completed-appts",
          },
          {
            name: "icu",
            id: "icu-tab",
          },
          {
            name: "messages",
            id: "messaging",
          },
        ];
        // set first enabled tab as active
        if (this.activeTab) {
          this.changeAppHeaderText(this.activeTab);
        } else {
          for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (this.user.tabsEnabled[tab.name]) {
              this.$store.commit("setState", {
                stateName: "homePageActiveTab",
                stateValue: tab.id,
              });
              this.changeAppHeaderText(tab.id);
              break;
            }
          }
        }

        this.$root.onBackButton = () => {
          let that = this;
          if (this.$sidebar.showSidebar) {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
          } else {
            swal
              .fire({
                title: that.$t("message.Are you sure?"),
                confirmButtonText: that.$t("message.Exit"),
                showCancelButton: true,
                cancelButtonText: that.$t("message.Stay"),
              })
              .then(async (result) => {
                if (result && result.value) {
                  navigator.app.exitApp();
                }
              });
          }
        };
        let user = await this.$store.dispatch("getUserById", this.user._id);
        try {
          let userEndpoint = await this.$store.dispatch(
            "getEndpointByDeviceType",
            this.user._id
          );
          if (userEndpoint && userEndpoint._id) {
            user.endpoint = userEndpoint;
          }
        } catch (e) {
          console.log(e);
        }

        localStorage.user = JSON.stringify(user);
      } catch (e) {
        console.log(e);
      }

      await this.$store.dispatch("getSettings");

      this.init();

      this.initSocket();

      window.initSocket = this.initSocket;

      //Socket Events Handler
      socket.on("appointmentListUpdate", async function () {
        that.getWaitingAppointments();
        that.getScheduledAppointments();
      });

      socket.on("appointmentJoined", function (data) {
        if (that.user._id != data.userId) {
          that.getWaitingAppointments();
          that.getScheduledAppointments();
        }
      });

      socket.on("appointmentExit", async (data) => {
        if (that.user._id != data.userId) {
          that.getWaitingAppointments();
          that.getScheduledAppointments();
        }
      });

      socket.on("newMessage", async (data) => {
        if (data.toUser == that.user._id) {
          that.getMessages();
          that.$refs["message-badge"].$el.style.display = "inline-block";
          that.unreadChatList.push(data.messageId);
        }
      });

      socket.on("newChatMessage", async (message) => {
        if (
          message.chatMessage.username !=
          this.incomingCallAppt.provider.username
        ) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          }
        }
      });

      window.onAppResume = () => {
        setTimeout(() => {
          that.init();
        }, 0);
      };

      if (that.FCMpayload) {
        if (
          that.FCMpayload.type == "callNotification" &&
          that.FCMpayload.appointmentId
        ) {
          that.onCallPushNotification(that.FCMpayload);
          that.$store.state.FCMpayload = null;
        }
      }

      cordova.plugins.firebase.messaging.onMessage(async function (payload) {
        console.log("New foreground FCM message: ", payload);
        if (payload.type == "callNotification" && payload.appointmentId) {
          that.onCallPushNotification(payload);
          that.$store.state.FCMpayload = null;
        }
      });

      cordova.plugins.firebase.messaging.onBackgroundMessage(async function (
        payload
      ) {
        console.log("New background FCM message inside doc home: ", payload);
        if (payload.type == "callNotification" && payload.appointmentId) {
          that.onCallPushNotification(payload, true);
          that.$store.state.FCMpayload = null;
        } else {
          that.getWaitingAppointments();
          that.getScheduledAppointments();
        }
      });
    } else {
      console.log("no user");
      this.$router.push({ path: "/signin" });
    }
  },
  beforeDestroy() {
    this.$root.onBackButton = null;
    socket.off("appointmentListUpdate");
    socket.off("appointmentJoined");
    socket.off("newMessage");

    window.initSocket = null;
  },
};
</script>

<style scoped>
/* #home {
      margin-top: 1em;
  } */
#home .stats {
  text-align: center;
}

.search-block {
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}

.not-found-img {
  width: 100%;
}

.card-header-nav {
  background: var(--color-primary);
}

.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}

.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

#home .tab-content.tab-subcategories {
  width: 100%;
}

.main-panel > .content {
  margin-top: 0px;
}

.nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  /* Changed from 18px to fix message icon tab not visible in telemed.vue */
  margin-right: 8px;
}

.icon .nav-link {
  padding: 0px 15px !important;
}

.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
#care-card-front,
.care-card-description {
  height: 18em;
}

.care-card-description {
  overflow: scroll;
}

.image-text-overlay {
  font-size: 0.7em;
}

.appointments-wrapper {
  margin-top: 1em;
}

.icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin: auto;
  margin-top: 8px;
  border-radius: 30%;
}

.icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 2.8;
  font-size: 25px;
}

.link-label {
  margin-top: 1em;
  display: block;
}

.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}

/deep/ .tab-content {
  height: calc(100% - 68px);
  /* for fixed pagination from bottom */
  position: relative;
}

.content > div,
.content > div > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}

.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.message-list:first-child {
  border-top: none;
}

.message-list.selected {
  background-color: whitesmoke;
}

.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

.icon.icon-circle img {
  padding: 20px;
}

/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}

/deep/ .sc-message {
  width: 90%;
}

/deep/ .sc-header {
  display: none;
}

/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 70px;
}

body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}

body .dribbble {
  position: fixed;
  display: block;
  right: 20px;
  bottom: 20px;
}

body .dribbble img {
  display: block;
  height: 28px;
}

@media (max-width: 375px) {
  i.fa.fa-clock {
    right: 235px;
  }
}

@media (min-width: 768px) {

  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {

  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {

  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}
</style>
